"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.integerRange = void 0;
const validation_1 = require("@fmtk/validation");
function integerRange(min, max) {
    const base = (0, validation_1.integer)();
    return (ctx) => {
        const result = base(ctx);
        if (!result.ok) {
            return result;
        }
        if (result.value < min || result.value > max) {
            return {
                ok: false,
                errors: [
                    {
                        id: 'EXPECTED_RANGE',
                        field: ctx.field,
                        text: `expected integer in range ${min}-${max}`,
                    },
                ],
            };
        }
        return result;
    };
}
exports.integerRange = integerRange;
//# sourceMappingURL=integerRange.js.map